import {
  Component,
  input,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { DynamicFormComponent } from 'src/app/core/dynamic-form/dynamic-form.component';
import {
  DynamicFormOptions,
  FieldConfig,
  FieldTypeEnum,
} from 'src/app/core/dynamic-form/dynamicForm.interface';
import { EditHistoryData } from 'src/app/core/edit-history/edit-history';
import { ToastService } from 'src/app/core/toast/toast.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { environment } from 'src/environments/environment';

import { DynamicFormModule } from 'src/app/core/dynamic-form/dynamic-form.module';
import { EditHistoryModule } from 'src/app/core/edit-history/edit-history.module';
import { CommonModule } from '@angular/common';
import { StorieEnigmiService } from '../storie-enigmi.service';
import { StoryDto, UpdateStory, CreateStory } from '../storie-dto';
import { GenericDD } from 'src/app/model/generic-data';
import { MissionDto } from '../../gestione-missioni/missioni-dto';
import { EnigmaDto } from '../../gestione-enigmi/enigmi-dto';
import { customBreadCrumbRequest } from 'src/app/core/bread-crumbs/bread-crumbs.component';

@Component({
  selector: 'app-form-storie-enigmi',
  templateUrl: './form-storie-enigmi.component.html',
  styleUrl: './form-storie-enigmi.component.scss',
  imports: [CommonModule, DynamicFormModule, EditHistoryModule],
})
export class FormStorieEnigmiComponent implements OnInit, OnDestroy {
  @ViewChild('myForm') myForm!: DynamicFormComponent;

  idEnigma = input<string>('');
  internalEnigmaId = signal<string>('');
  //DATA FROM API, THE ONE THAT GETS CHANGED AND THE OG ONE
  //CHANGE THE TYPE TO THE ONE YOU NEED
  public object?: StoryDto;

  //ID
  codice: string = '';

  //FORM OPTIONS, DEFINED IN CONSTRUCTOR
  form2Opts: DynamicFormOptions;

  //FOR SHOWING OR HIDING FORM, USEFULL FOR REINITIALIZING
  ready: boolean = false;

  //FOR SHOWING CREATEDBY AND EDITEDBY
  editHistoryData: EditHistoryData | undefined;

  //FORM FIELDS
  regConfig2: FieldConfig[] = [];

  // enigma list from mission
  currentEnigma: EnigmaDto[] = [];
  currentDataForDD: GenericDD[] = [];

  //NO MEMORY LEAKS FIX
  private theEnd$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute, //IF YOU USE paramMap
    private router: Router,
    private toast: ToastService,
    private storyService: StorieEnigmiService,
    private localStorageService: LocalStorageService
  ) {
    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
    };
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngOnInit(): void {
    if (this.idEnigma()) {
      console.warn("GOT ID FROM ENIGMA");
      this.internalEnigmaId.set(this.idEnigma());
    } else {
      console.warn("GOT ID FROM ROUTE");
      this.internalEnigmaId.set(this.route.snapshot.paramMap.get('id') ?? '');
    }

    console.warn(this.internalEnigmaId())

    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
      editOptions: {
        entityName: 'story', //for lockserver apis
        entityDisplayName: 'Storia', //placeholder for messages
        deleteUrl: `${environment.apiUrl}/storys`, //delete url
        deleteMessage: `Stai per eliminare la storia, procedere?`, //message on delete dialog
        deleteItem: '', //delete code/id depends, assign this when initializing form
        entityId: '', //id for lockserver apis
        isFem: false, //is fem or male?
        redirectUrl: `home/enigmi/${this.internalEnigmaId()}`, //url where it goes after delete
      },
      addOptions: {
        entityName: 'story',
        entityDisplayName: 'Storia',
        isFem: false,
        redirectUrl: `home/enigmi/${this.internalEnigmaId()}`, //url where it goes when cancelling
      },
    };

    this.initializeForm();
  }

  goBackToEnigma() {
    this.router.navigate(['home/enigmi', this.internalEnigmaId()]);
  }

  /* getEnigmasMission() {
    this.storyService.getEnigmasByMission(this.internalEnigmaId()).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: EnigmaDto[]) => {

      }
    })
  }
 */

  //based on route decides what form to show, adapt this logic if url contains more add or edit strings
  initializeForm() {
    if (this.router.url.includes('new')) {
      this.form2Opts.formType = 'add';
      this.localStorageService.setTitolo('Nuova storia');
      this.initializeFormFields();
    } else {
      this.form2Opts.formType = 'edit';
      this.initializeEditForm();
    }
  }

  initializeFormFields() {
    this.regConfig2 = [
      {
        type: FieldTypeEnum.input,
        name: 'title',
        label: 'Titolo',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.title : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci un nome',
          },
        ],
      },
      {
        type: FieldTypeEnum.textarea,
        name: 'content',
        label: 'Content',
        isRequired: true,
        width: 'w-full',
        value: this.object ? this.object.content : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci un nome',
          },
        ],
      },
      {
        type: FieldTypeEnum.file,
        name: 'image',
        label: 'Carica immagine',
        width: 'w-full',
        value: this.object ? this.object.image : '',
        fileUploadType: 'image/png,image/jpeg,image/jpg,image/webp',
      },
      // {
      //   type: FieldTypeEnum.input,
      //   name: 'description',
      //   label: 'Descrizione',
      //   isRequired: true,
      //   width: 'w-1/2',
      //   value: this.object ? this.object.description : undefined,
      //   validations: [
      //     {
      //       name: 'required',
      //       validator: Validators.required,
      //       message: 'Inserisci una descrizione',
      //     },
      //   ],
      // },
    ];

    this.ready = true;
  }

  //make api call and get data for edit
  initializeEditForm() {
    this.codice = this.route.snapshot.paramMap.get('id') || '';

    this.storyService
      .read(this.codice)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: StoryDto) => {
          this.object = _.cloneDeep(response);

          this.internalEnigmaId.set(this.object.enigmaFk || '');

          this.localStorageService.setTitolo(
            `Modifica storia ${response.title}`
          );

          let req: customBreadCrumbRequest = {
            oldString: response.id,
            newString: response.title,
          }
          this.localStorageService.setCustomBreadCrumb(req);

          if (this.form2Opts.editOptions) {
            this.form2Opts.editOptions.deleteItem = '' + this.object.id;
            this.form2Opts.editOptions.entityId = this.object.id;
          }

          //run this method to display form
          this.initializeFormFields();
        },
        error: () => {},
      });
  }

  //fires when submitting
  submit(event: any) {
    if (this.form2Opts.formType == 'add') {
      this.add(event);
    } else {
      this.edit(event);
    }
  }

  //edit submit
  edit(event: any) {
    console.log(event);
    let data: UpdateStory = {
      title: event.title,
      content: event.content,
      enigmaFk: this.internalEnigmaId(),
      image: event.image || '',
    };

    this.storyService
      .update(this.codice, data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: StoryDto) => {
          this.toast.success('Modifiche salvate');
        },
        error: () => {},
      });
  }

  //add submit
  add(event: any) {
    console.log(event);
    let data: CreateStory = {
      title: event.title,
      content: event.content,
      enigmaFk: this.internalEnigmaId(),
      image: event.image || '',
    };

    this.storyService
      .create(data)
      .pipe(takeUntil(this.theEnd$))
      .subscribe({
        next: (response: StoryDto) => {
          this.toast.success('Storia creata');
          this.router.navigate(['home/storie', response.id]);
        },
        error: () => {},
      });
  }

}
